import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CMSiteEmployeesAccept } from '../models/cm-club-service.model';
import { CMContract, ContractResponse, CMContractSetting, CMContractSettingResponse, Contact, CMContractNavListResponse, CMNavigationResponse, eCMNavigation_Update_Type, ContractAcceptation, CMContractListResponse, CMContractFeeListResponse, CMMemberFeeListResponse, PaymentReviewListResponse, ContractTextMessage, ContractPdfConvertContainer, CMContractLstResponse, CMContractListRequest, CMContractLog, CMSession, CMContractLogListResponse, CMAPILogListResponse, REF_CMStatusResponse } from '../models/cm-contract';
import { SimpleResponse } from '../models/generic-response.model';
import { delayedRetryHttp } from './shared/delayed-retry';
import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class CMContractService {

    private baseUrl: string;
    private api: string = 'api/CMContract';


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async cmContractGet(encryptedUser: string, clpCompanyId: number, clubId: number, siteId: number, contractId: number): Promise<ContractResponse | void> {
        const a = await this.httpClient
            .get<ContractResponse>(`${this.baseUrl}/CMContract_Get/${clpCompanyId}?clubID=${clubId}&siteID=${siteId}&contractId=${contractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpCompanyId - " + clpCompanyId + "," + "clubId - " + clubId + "," + "siteId - " + siteId, encryptedUser, "CMContractService", "cmContractGet"); });
        return a;
    }

    async cmContractGetById(encryptedUser: string, clpuserID: number, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMMember_GetContractID/${clpuserID}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserID - " + clpuserID + "," + "contactID - " + contactID, encryptedUser, "CMContractService", "cmContractGet"); });
        return a;
    }

    async CMContract_Update(encryptedUser: string, contract: CMContract): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContract_Update`, contract, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_Update"); });
        return a;
    }

    async cMContract_CheckForReservationId(encryptedUser: string, clpCompanyId: number, contractID: number, lastActionID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_CheckForReservationId/${clpCompanyId}/${contractID}/${lastActionID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractID - " + contractID, "", "CMContractService", "cMContract_CheckForReservationId"); });
        return a;
    }

    async cMContract_GetResNetAccountStatus(encryptedUser: string, clpCompanyId: number, contractID: number, contactId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_GetResNetAccountStatus/${clpCompanyId}/${contractID}/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractID - " + contractID, "", "CMContractService", "cMContract_GetResNetAccountStatus"); });
        return a;
    }

    async cMContractFee_Create(encryptedUser: string, cmContractID: number, feeBase: number, feeTax: number, sOrder: number, cmProductFeeID: number, cmFeeName: string): Promise<CMContractListResponse | void> {
        const a = await this.httpClient
            .get<CMContractListResponse>(`${this.baseUrl}/CMContractFee_Create/${cmContractID}/${feeBase}/${feeTax}/${sOrder}/${cmProductFeeID}/${cmFeeName}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "cmContractID - " + { cmContractID }, "", "CMContractService", "cMContractFee_Create"); });
        return a;
    }

    async CMSiteEmployees_SignAccepted(encryptedUser: string, empAccept: CMSiteEmployeesAccept, isSignUpdate: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMSiteEmployees_SignAccepted?isSignUpdate=${isSignUpdate}`, empAccept, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMSiteEmployees_SignAccepted"); });
        return a;
    }

    async CMContract_Delete(encryptedUser: string, contractId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContract_Delete?cmContractId=${contractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_Delete"); });
        return a;
    }


    async cmMemberDelete(encryptedUser: string, memberId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMMember_Delete/${memberId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmMemberDelete"); });
        return a;
    }


    async LoadContractMemberDisplay(encryptedUser: string, contactId: number): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/LoadContractMemberDisplay/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "contactId - " + contactId, encryptedUser, "CMContractService", "getContactDetails"); });
        return a;
    }

    async cmSiteContractSetting_Get(encryptedUser: string, siteId: number): Promise<CMContractSettingResponse | void> {
        const a = await this.httpClient
            .get<CMContractSettingResponse>(`${this.baseUrl}/CMSiteContractSetting_Get/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "siteId - " + siteId, encryptedUser, "CMContractService", "cmSiteContractSetting_Get"); });
        return a;
    }

    async cmSiteContractSetting_Update(encryptedUser: string, setting: CMContractSetting): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMSiteContractSetting_Update`, setting, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmSiteContractSetting_Update"); });
        return a;
    }

    async CMContact_Save(encryptedUser: string, contact: Contact, siteSelected: number = 0, CMContractActive: boolean = false): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContact_Save`, contact, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContact_Save"); });
        return a;
    }

    async cMContractNavCreate(encryptedUser: string, contractId: number, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContractNav_Create/${contractId}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cMContractNavCreate"); });
        return a;
    }

    async navigation_Create(encryptedUser: string, contractId: number, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMNavigation_Create/${contractId}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cMContractNavCreate"); });
        return a;
    }

    async navigationGet(encryptedUser: string, contractId: number, contactID: number): Promise<CMNavigationResponse | void> {
        const a = await this.httpClient
            .get<CMNavigationResponse>(`${this.baseUrl}/CMNavigation_Get/${contractId}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "navigationGet"); });
        return a;
    }

    async navigationUpdate(encryptedUser: string, cMNavigationID: number, update_Type: eCMNavigation_Update_Type, value: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMNavigation_Update/${cMNavigationID}/${update_Type}/${value}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "navigationUpdate"); });
        return a;
    }

    async productGet(encryptedUser: string, clpcompanyID: number, contractId: number, contactID: number, cmroductDocId: number, cmContractNavID: number): Promise<CMContractNavListResponse | void> {
        const a = await this.httpClient
            .get<CMContractNavListResponse>(`${this.baseUrl}/CMContractNav_Get/${clpcompanyID}/${contractId}/${contactID}?cmroductDocId=${cmroductDocId}&cmContractNavID=${cmContractNavID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "productGet"); });
        return a;
    }

    async cmContractNavisAccepted(encryptedUser: string, _cmAccept: ContractAcceptation): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContractNav_isAccepted`, _cmAccept, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContractNavisAccepted"); });
        return a;
    }

    async sendMemberEmail(encryptedUser: string, toContactID: number, contractID: number, clpCompanyID: number, cLPUserId: number, scLPUserId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/SendMemberEmail/${toContactID}/${contractID}/${clpCompanyID}/${cLPUserId}/${scLPUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "sendMemberEmail"); });
        return a;
    }

    async sendMemberText(encryptedUser: string, toContactID: number, contractID: number, clpCompanyID: number, clpUserID: number, sclpUserID: number, txtMsg: string, mediaURL: string, sendEmail: boolean): Promise<SimpleResponse | void> {
        let t: ContractTextMessage = {
            toContactID: toContactID,
            contractID: contractID,
            clpCompanyID: clpCompanyID,
            clpUserID: clpUserID,
            sclpUserID: sclpUserID,
            txtMsg: txtMsg,
            mediaURL: mediaURL,
            sendEmail: sendEmail
        }
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/SendMemberText`, t, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "sendMemberText"); });
        return a;
    }

    async unixTimestamp(contractId: number, clpCompanyID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/UnixTimestamp/${contractId}/${clpCompanyID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpCompanyID - " + { clpCompanyID } + "contractId -" + contractId, "", "CMContractService", "unixTimestamp"); });
        return a;
    }

    async cMContractFee_Get(encryptedUser: string, cmContractID: number): Promise<CMContractFeeListResponse | void> {
        const a = await this.httpClient
            .get<CMContractFeeListResponse>(`${this.baseUrl}/CMContractFee_Get/${cmContractID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "cmContractID - " + { cmContractID }, "", "CMContractService", "cMContractFee_Create"); });
        return a;
    }

    async getMemberFee(encryptedUser: string, contractId: number, cmMemberID: number): Promise<CMMemberFeeListResponse | void> {
        const a = await this.httpClient
            .get<CMMemberFeeListResponse>(`${this.baseUrl}/CMMemberFee_Get/${contractId}/${cmMemberID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "getMemberFee"); });
        return a;
    }

    async GetPaymentReviews(encryptedUser: string, clpcompanyID: number, siteID: number, contractId: number, memberID: number): Promise<PaymentReviewListResponse | void> {
        const a = await this.httpClient
            .get<PaymentReviewListResponse>(`${this.baseUrl}/GetPaymentReviews/${clpcompanyID}/${siteID}/${contractId}/${memberID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "GetPaymentReviews"); });
        return a;
    }

    async cMMember_Exists(encryptedUser: string, contactId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMMember_Exists/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cMMember_Exists"); });
        return a;
    }

    async GetContractPDFAsync(encryptedUser: string, fileName: string, fileLength: number): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/GetContractPDF/${fileName}/${fileLength}`, {
                'responseType': 'arraybuffer' as 'json',
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "GetContractPDFAsync"); });
        return a;
    }

    async getTextMessagePH(encryptedUser: string, userId: number, contacId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/GetTextMessagePH/${userId}?contacId=${contacId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "getTextMessagePH"); });
        return a;
    }
    async ProcessorContractPDFConvert_Add(encryptedUser: string, clpCompanyId: number, contractId: number, contactId: number, siteId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/ProcessorContractPDFConvert_Add/${clpCompanyId}/${contractId}/${contactId}/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "ProcessorContractPDFConvert_Add"); });
        return a;
    }

    async ProcessorContractPDFConvert_Get(encryptedUser: string, clpCompanyId: number, contractId: number, contactId: number, siteId: number, isAllMember: boolean): Promise<ContractPdfConvertContainer | void> {
        const a = await this.httpClient
            .get<ContractPdfConvertContainer>(`${this.baseUrl}/ProcessorContractPDFConvert_Get/${clpCompanyId}/${contractId}/${contactId}/${siteId}/${isAllMember}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "ProcessorContractPDFConvert_Get"); });
        return a;
    }

    async ProcessorContractPDFConvert_Archive(encryptedUser: string, clpCompanyId: number, contractId: number, contactId: number, siteId: number, isAllMember: boolean): Promise<ContractPdfConvertContainer | void> {
        const a = await this.httpClient
            .get<ContractPdfConvertContainer>(`${this.baseUrl}/ProcessorContractPDFConvert_Archive/${clpCompanyId}/${contractId}/${contactId}/${siteId}/${isAllMember}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "ProcessorContractPDFConvert_Archive"); });
        return a;
    }

    async ProcessorDLContractPDFConvert_Get(encryptedUser: string, clpCompanyId: number, contractId: number, contactId: number, siteId: number): Promise<ContractPdfConvertContainer | void> {
        const a = await this.httpClient
            .get<ContractPdfConvertContainer>(`${this.baseUrl}/ProcessorDLContractPDFConvert_Get/${clpCompanyId}/${contractId}/${contactId}/${siteId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "ProcessorDLContractPDFConvert_Get"); });
        return a;
    }

    async cmContractStatusUpdate(encryptedUser: string, contractId: number, clpCompanyId: number, clpUserId: number, sclpUserId: number, contactId: number, isFaceToFace: number, statusID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_Status_Update/${contractId}/${clpCompanyId}/${clpUserId}/${sclpUserId}/${contactId}/${isFaceToFace}/${statusID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContractStatusUpdate"); });
        return a;
    }

    async cmMemberStatusUpdate(encryptedUser: string, contractId: number, clpUserId: number, sclpUserId: number, contactId: number, isFaceToFace: number, memberId: number, statusId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMMember_Status_Update/${contractId}/${clpUserId}/${sclpUserId}/${contactId}/${isFaceToFace}/${memberId}/${statusId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContractStatusUpdate"); });
        return a;
    }

    async dtSignedMembers_Update(encryptedUser: string, contractId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_dtSignedMembers_Update/${contractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContractStatusUpdate"); });
        return a;
    }

    async cMContractGetList(encryptedUser: string, clpuserId: number, cMContractListRequest: CMContractListRequest): Promise<CMContractLstResponse | void> {
        const a = await this.httpClient
            .post<CMContractLstResponse>(`${this.baseUrl}/CMContract_GetList/${clpuserId}`, cMContractListRequest, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_GetList"); });
        return a;
    }

    async CMContractLog_Create(encryptedUser: string, log: CMContractLog): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContractLog_Create`, log, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContractLog_Create"); });
        return a;
    }

    async CMContract_Update_SessionId(encryptedUser: string, session: CMSession): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CMContract_Update_SessionId`, session, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_Update_SessionId"); });
        return a;
    }

    async CMContract_Get_SessionId(encryptedUser: string, cmContractId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_Get_SessionId/${cmContractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "cmContractId - " + cmContractId, encryptedUser, "CMContractService", "CMContract_Get_SessionId"); });
        return a;
    }

    async cMContractLog_GetList(encryptedUser: string, cmContractId: number, sClpUserId: number): Promise<CMContractLogListResponse | void> {
        const a = await this.httpClient
            .get<CMContractLogListResponse>(`${this.baseUrl}/CMContractLog_GetList/${cmContractId}/${sClpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "cmContractId - " + cmContractId, encryptedUser, "CMContractService", "cMContractLog_GetList"); });
        return a;
    }

    async CMAPILog_GetList(encryptedUser: string, cmContractId: number): Promise<CMAPILogListResponse | void> {
        const a = await this.httpClient
            .get<CMAPILogListResponse>(`${this.baseUrl}/CMAPILog_GetList/${cmContractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "cmContractId - " + cmContractId, encryptedUser, "CMContractService", "CMAPILog_GetList"); });
        return a;
    }

    async CM_MemberDLFileUpload(encryptedUser: string, formData: any, contractId: number, clpCompanyId: number, cmMemberId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/CM_MemberDLFileUpload?contractId=${contractId}&clpCompanyId=${clpCompanyId}&cmMemberId=${cmMemberId}`, formData, {
                headers: new HttpHeaders({
                    //'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CM_MemberDLFileUpload"); });
        return a;
    }

    async CMContract_CheckMemberDL(encryptedUser: string, contractId: number, clpCompanyId: number, contactId: number, siteId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_CheckMemberDL/${contractId}/${clpCompanyId}/${contactId}/${siteId}`, {
                headers: new HttpHeaders({
                    //'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_CheckMemberDL"); });
        return a;
    }

    async ContractOpenAutomation(encryptedUser: string, clpcompanyId: number, contractID: number, contactID: number, is_client: boolean): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/ContractOpenAutomation/${clpcompanyId}/${contractID}/${contactID}/${is_client}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "CMContract_CheckMemberDL"); });
        return a;
    }

    async cMSiteEmployees_Signature_Get(encryptedUser: string, clpcompanyId: number, cmEmployeeId: number, clpUserId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMSiteEmployees_Signature_Get/${clpcompanyId}/${cmEmployeeId}/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cMSiteEmployees_Signature_Get"); });
        return a;
    }

    async cMSiteEmployees_Signature_Delete(encryptedUser: string, clpcompanyId: number, cmEmployeeId: number, clpUserId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMSiteEmployees_Signature_Delete/${clpcompanyId}/${cmEmployeeId}/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cMSiteEmployees_Signature_Delete"); });
        return a;
    }

    /**
     * Resets all member signatures, document acceptances, and wizard navigation state
     * for a contract that was modified after members signed but before "Charge" was clicked.
     * Clears Azure blobs, CMMember signature columns, CMContractNav acceptance flags,
     * CMNavigation wizard-step flags, and resets member/contract statuses.
     */
    async cmContract_ResetSignatures(encryptedUser: string, contractId: number, clpcompanyId: number, clpUserId: number, sclpUserId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_ResetSignatures/${contractId}/${clpcompanyId}/${clpUserId}/${sclpUserId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContract_ResetSignatures"); });
        return a;
    }

    async addAgreementOpenLCCard(encryptedUser: string, contactId: number, clpUserID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/AddAgreementOpenLCCard/${contactId}/${clpUserID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "AddAgreementOpenLCCard"); });
        return a;
    }

    async cmContractStatus_GetList(encryptedUser: string): Promise<REF_CMStatusResponse | void> {
        const a = await this.httpClient
            .get<REF_CMStatusResponse>(`${this.baseUrl}/CMContractStatus_GetList`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + ",", encryptedUser, "CMContractService", "cmContractStatus_GetList"); });
        return a;
    }

    async cmMemberStatus_GetList(encryptedUser: string): Promise<REF_CMStatusResponse | void> {
        const a = await this.httpClient
            .get<REF_CMStatusResponse>(`${this.baseUrl}/CMMemberStatus_GetList`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + ",", encryptedUser, "CMContractService", "cmMemberStatus_GetList"); });
        return a;
    }

    async cmContractType_GetList(encryptedUser: string): Promise<REF_CMStatusResponse | void> {
        const a = await this.httpClient
            .get<REF_CMStatusResponse>(`${this.baseUrl}/CMContractType_GetList`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + ",", encryptedUser, "CMContractService", "cmContractType_GetList"); });
        return a;
    }

    async sendToReservation(encryptedUser: string, empAccept: CMSiteEmployeesAccept): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/SendToReservation`, empAccept, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "sendToReservation"); });
        return a;
    }

    async cmContract_Get_RESNET_Contract_Notes(encryptedUser: string, cmContractId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMContract_Get_RESNET_Contract_Notes/${cmContractId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "cmContract_Get_RESNET_Contract_Notes"); });
        return a;
    }

    async processSubscriptions(encryptedUser: string, empAccept: CMSiteEmployeesAccept): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ProcessSubscriptions`, empAccept, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "processSubscriptions"); });
        return a;
    }

    async processEmails(encryptedUser: string, empAccept: CMSiteEmployeesAccept): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ProcessEmails`, empAccept, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "CMContractService", "processEmails"); });
        return a;
    }
}
